import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import FooterMenu from '../../components/Guest/Footer/Footer';
import './HomeEventAndFacilityAll.css';

@inject('CmsEventHotelStore', 'CmsFacilityHotelStore')
@observer
class HomeEventAndFacilityAll extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { CmsEventHotelStore, CmsFacilityHotelStore } = this.props;
    CmsEventHotelStore.getAllByLanguage();
    CmsFacilityHotelStore.getAllByLanguage();
  }

  // ==================== Data Transformation ====================

  parseBannerImages = (bannerUrl) => {
    try {
      if (!bannerUrl) return [];
      const images = typeof bannerUrl === 'string' ? JSON.parse(bannerUrl) : bannerUrl;
      return Array.isArray(images) ? images : [];
    } catch (e) {
      console.warn('Failed to parse bannerUrl:', e);
      return [];
    }
  };

  getLocalizedTitle = (item) => {
    if (item.title) return item.title;
    const langs = item.eventHotelLanguages || item.facilityHotelLanguages || [];
    return (langs.length > 0 && langs[0].title) ? langs[0].title : '';
  };

  getLocalizedDescription = (item) => {
    let desc = item.briefDescription || item.description || '';
    if (!desc) {
      const langs = item.eventHotelLanguages || item.facilityHotelLanguages || [];
      if (langs.length > 0) {
        desc = langs[0].briefDescription || langs[0].description || '';
      }
    }
    return desc.replace(/<[^>]*>/g, '');
  };

  transformToCard = (item, source) => {
    const images = this.parseBannerImages(item.bannerUrl);
    const imageUrl = images.length > 0 ? (images[0].url || '') : '';
    const title = this.getLocalizedTitle(item);
    const description = this.getLocalizedDescription(item);

    return {
      id: item.id,
      imageUrl,
      title,
      description,
      source,
    };
  };

  // ==================== Data Getters ====================

  getEventData = () => {
    const { CmsEventHotelStore } = this.props;
    const events = CmsEventHotelStore.eventHotels || [];
    return events.map((item) => this.transformToCard(item, 'event'));
  };

  getFacilityData = () => {
    const { CmsFacilityHotelStore } = this.props;
    const facilities = CmsFacilityHotelStore.facilityHotels || [];
    return facilities.map((item) => this.transformToCard(item, 'facility'));
  };

  // ==================== Navigation ====================

  handleCardClick = (item) => {
    const { history } = this.props;
    if (item.source === 'event') {
      history.push(`/event/${item.id}`);
    } else if (item.source === 'facility') {
      history.push(`/facility/${item.id}`);
    }
  };

  handleBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  // ==================== Render Helpers ====================

  renderCard = (item) => {
    return (
      <div
        className="stm-efa-card"
        key={`${item.source}-${item.id}`}
        onClick={() => this.handleCardClick(item)}
      >
        {/* 左侧正方形缩略图 */}
        <div className="stm-efa-card-thumb">
          {item.imageUrl ? (
            <img
              src={item.imageUrl}
              alt={item.title}
              className="stm-efa-card-thumb-img"
            />
          ) : (
            <div className="stm-efa-card-thumb-placeholder">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c0c0c0" strokeWidth="1.5">
                <rect x="3" y="3" width="18" height="18" rx="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <path d="M21 15l-5-5L5 21" />
              </svg>
            </div>
          )}
        </div>

        {/* 中间文字区 */}
        <div className="stm-efa-card-text">
          <div className="stm-efa-card-title">
            {item.title || '—'}
          </div>
          {item.description && (
            <div className="stm-efa-card-desc">{item.description}</div>
          )}
        </div>

        {/* 右侧箭头 */}
        <div className="stm-efa-card-arrow">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M9 6L15 12L9 18" stroke="#1a1a1a" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>
    );
  };

  // ==================== Render ====================

  render() {
    const { t } = this.props;
    const eventData = this.getEventData();
    const facilityData = this.getFacilityData();

    return (
      <div className="stm-efa-page">
        {/* ===== 英雄横幅头部 ===== */}
        <div className="stm-efa-hero">
          <button className="stm-efa-back-btn" onClick={this.handleBack} aria-label="Back">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M19 12H5m0 0l7-7m-7 7l7 7" stroke="#fff" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <div className="stm-efa-hero-content">
            <h1 className="stm-efa-hero-title">Explore Our Hotel</h1>
          </div>
        </div>

        {/* ===== 内容区 ===== */}
        <div className="stm-efa-content" style={{ marginBottom: '60px' }}>
          {eventData.length === 0 && facilityData.length === 0 && (
            <div className="stm-efa-empty">
              <p>{t ? t('noData') : ''}</p>
            </div>
          )}
          <div className="stm-efa-list">
            {eventData.map((item) => this.renderCard(item))}
            {facilityData.map((item) => this.renderCard(item))}
          </div>
        </div>

        <FooterMenu history={this.props.history} menuText={'home'} />
      </div>
    );
  }
}

export default withTranslation()(HomeEventAndFacilityAll);
